import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  errorText: {
    color: "#D92D20",
    margin: "0",
    display: "flex",
    fontSize: "14px",
    fontStyle: "normal",
    alignItems: "center",
    fontFamily: "Manrope",
    fontWeight: "normal",
    lineHeight: "24px",
  },
  iconError: {
    fill: "currentColor",
    width: "16px",
    height: "16px",
    display: "inline-block",
    fontSize: "1.5rem",
    transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    flexShrink: 0,
    userSelect: "none",
    marginRight: "5px",
  },
}));

export default styles;
